import { render, staticRenderFns } from "./UserBalanceBalancesWithdrawalBalanceModal.vue?vue&type=template&id=80c92b2a&"
import script from "./UserBalanceBalancesWithdrawalBalanceModal.vue?vue&type=script&lang=js&"
export * from "./UserBalanceBalancesWithdrawalBalanceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports